import { render, staticRenderFns } from "./ContactUs.vue?vue&type=template&id=3ec573ca&scoped=true&"
var script = {}
import style0 from "./ContactUs.vue?vue&type=style&index=0&id=3ec573ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec573ca",
  null
  
)

export default component.exports